/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import PurchaseIcon from "../../../../../assets/images/icon_menus/PurchaseIcon.json";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { Button, TextField, Box, Switch, FormControlLabel, FormControl, FormLabel, RadioGroup, Radio, InputAdornment, IconButton, Tooltip } from "@mui/material";
import { SelectedIcon, UnSelectedIcon } from "../../../../Shared/components/Icons/selectedIcon";
import { Col, Image, Row } from "antd";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import Typography from '@mui/material/Typography';
import Search from "../../../../Shared/components/Icons/Search"
import crudActions from "../../../../CRUD/redux/actions";
import addressActions from "../../../../Admin/Address/redux/actions";
import groupActions from "../../../Setup/redux/actions";
import gstActions from "../../../../Admin/Setup/redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import actions from "../../redux/actions";
// import businessActions from "../../../../Admin/Home/redux/actions";
import { customerTypeList, classificationList } from "../../../../../config/constant";
import {
    emptyValidation, customEmailValidation, customAlaphaNumericValidation,
    customAlaphaNumericValidationOptional
} from "../../../../../helpers/validation";
import { toast } from 'react-toastify';
import globalAddressActions from "../../../../Admin/Home/redux/actions";
import { CustomAccordion } from "../../../../Shared/components/AccordionComponent";
import { QuickLinks } from "../../../../Shared/components/BreadCrumbNew/QuickLinks";
import qucikLinksActions from "../../../../Dashboard/redux/actions";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { AddressTable } from "../../../../Shared/components/AddressTable";
import { checkCRUDViewPermission, checkCRUDPermission, capitalizeFirstLetter, scrollToError, getBusinessId, idNamingConversion } from "../../../../../helpers/utilities";
import CustomAlert from "../../../../Shared/components/CustomAlert";
import { AESEncrypt } from "../../../../../helpers/Crypto";
import younoteAdminSetupActions from "../../../../YounoteAdmin/Setup/redux/actions";
import { useEventListener } from "../../../../../helpers/useEventListener"
import infoMarkIcon from "../../../../../assets/images/icon_actions/infoMark.svg";

const SupplierCreate = (props) => {
    const [visible, setVisible] = useState(false);
    const { businessDetails } = useSelector(state => state.homeReducer);
    const { roleManagement } = useSelector(state => state.authReducer);
    const { areaDetails, languageDetails, pincodeDetails, stateDetails, countryDetails, cityDetails } = useSelector(state => state.addressReducer);
    const { taxType } = useSelector(state => state.younoteAdminSetupReducer);
    const { partyGstdetails, currencyDetails, mopDetails, taxCodedetails, cashDiscountDetails, otherTaxesdetails } = useSelector(state => state.adminSetupReducer);
    const { supplierGroupDetails } = useSelector(state => state.purchaseSetupReducer);
    const { addressDetails, addressLoader } = useSelector(state => state.homeReducer);
    const { createDetails, createError, createLoader, createData } = useSelector(state => state.crudReducer);
    const dispatch = useDispatch();
    const { history } = props;

    const [addressSearchAll, setAddressSearchAll] = useState('');
    const prevAddressSearchAll = usePrevious(addressSearchAll);
    const timeoutRef = useRef('');

    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const [iconAnimation, setIconAnimation] = useState(false);
    const [businessType, setBusinessType] = useState('');
    const [name, setName] = useState('');
    const [gabId, setGabId] = useState('');
    const [isHold, setIsHold] = useState(false);
    const [mobile, setMobile] = useState('');
    const [email, setEmail] = useState('');
    const [classification, setClassification] = useState('');
    const [languageId, setLanguageId] = useState(1);
    const [groupId, setGroupId] = useState('');
    const [gstCodeId, setGstCodeId] = useState('');
    const [gstin, setGstin] = useState('');
    const [address1, setAddress1] = useState('');
    const [priceIncludesTax, setPriceIncludesTax] = useState(false);
    const [areaId, setAreaId] = useState('');
    const [pincodeId, setPincodeId] = useState('');
    const [stateId, setStateId] = useState('');
    const [cityId, setCityId] = useState('');
    const [identityType, setIdentityType] = useState('');
    const [pan, setPan] = useState('');
    const [countryId, setCountryId] = useState('');
    const sortOrder = "asc";
    const sortBy = "contactName";
    const [younoteID, setYounoteID] = useState('');
    const [younoteSerial, setYounoteSerial] = useState('');

    const [taxCodeId, setTaxCodeId] = useState('');
    const [cashDiscountId, setCashDiscountId] = useState('');
    const [tcs, setTcs] = useState(false);
    const [tcsId, setTcsId] = useState('');
    const [tdsId] = useState('');
    const [tds, setTds] = useState(false);

    const [contactName, setContactName] = useState('');
    const [tradingName, setTradingName] = useState('');
    const [alternateMobile, setAlternateMobile] = useState('');
    const [mopId, setMopId] = useState('');
    const [currencyId, setCurrencyId] = useState('');
    const [inAppStatus, setInAppStatus] = useState("");

    const [errorBusinessType, setErroBusinessType] = useState(false);
    const [errorName, setErrorName] = useState(false);
    const [errorTcs, setErrorTcs] = useState(false);
    const [commonError, setCommonError] = useState(false);
    const [errorMobile, setErrorMobile] = useState(false);
    const [errorEmail, setErrorEmail] = useState(false);
    const [errorGstType, setErrorGstType] = useState(false);
    const [errorGstCode, setErrorGstCode] = useState(false);
    const [errorGstIn, setErrorGstIn] = useState(false);
    const [errorPincode, setErrorPincode] = useState(false);
    const [errorState, setErrorState] = useState(false);
    const [errorLanguage, setErrorLanguage] = useState(false);
    const [errorCurrency, setErrorCurrency] = useState(false);
    const [errorClassification, setErrorClassification] = useState(false);
    const [errorContactForm, setErrorContactForm] = useState(false);
    const [erroremptyAlternateName, setErroremptyAlternateName] = useState(false);
    //const [erroremptyAlternateNumber, setErroremptyAlternateNumber] = useState(false);
    const [gstTypeList, setGstTypeList] = useState([]);
    const [taxTypeId, setTaxTypeId] = useState('');
    const childRef = useRef('');

    const emptyState = () => {
        setErroBusinessType(false);
        setErrorName(false);
        setErrorMobile(false);
        setErrorEmail(false);
        setErrorGstType(false);
        setErrorLanguage(false);
        setErrorCurrency(false);
        setErrorGstCode(false);
        setErrorClassification(false);
        setErrorContactForm(false);
        setErroremptyAlternateName(false);
        //setErroremptyAlternateNumber(false);
        setErrorGstIn(false);
        setErrorPincode(false);
        setErrorState(false);
        setCommonError(false);
        setErrorTcs(false);
    }



    const handleKeyDown = (e) => {
        if (e.altKey && e.keyCode === 83) {
            e.preventDefault();
            handleSubmit(e);
        }
    };
    useEventListener("keydown", handleKeyDown);

    const selectAddress = (data) => {
        if (data?.stateId) {
            changeStateApi(data?.stateId);
        }

        if (data?.pincodeId) {
            dispatch({
                type: addressActions.AREA_DETAILS_START, url: 'areas', filter: {
                    where: { "and": [{ pincodeId: data?.pincodeId }] }
                }
            });
        }

        setName(data.businessName ? data.businessName : data.contactName && data.contactName);
        setMobile(data?.mobile || '');
        setEmail(data?.email || '');
        setGabId(data?.id || '');
        setAddress1(data?.address1 || '');
        setAreaId(data?.areaId || '');
        setPincodeId(data?.pincodeId || '');
        setCityId(data?.cityId || '');
        setStateId(data?.stateId || '');
        setCountryId(data?.countryId || '');
        setCurrencyId(data?.country?.currencyId || '');
        setContactName(data?.contactName || '');
        setYounoteID(data?.businessId || '');
        setYounoteSerial(data?.business?.serialNo || '');
        if (data?.businessId) {
            setInAppStatus('REQUEST SENT');
        } else {
            setInAppStatus('---');
        }
        setTaxTypeId(data?.taxTypeId);
        if (data?.gstNumber) {
            setGstin(data?.gstNumber);
            setGstCodeId(66);
        } else {
            setGstin('');
            setGstCodeId('');
        }
        handleClose();
    }

    const addressSearch = () => {
        let filter = { ["and"]: [{ isGloballyVisible: true }] };
        let or = { ["or"]: [] }

        if (name !== '' && name !== null && name.length > 6) {
            or['or'].push({ businessName: { like: name.trim() + '%' } });
            or['or'].push({ contactName: { like: name.trim() + '%' } });
            or['or'].push({ email: { like: name.trim() + '%' } });
        }
        if (mobile !== '' && mobile !== null && mobile.length >= 10) {
            filter['and'].push({ mobile: { like: mobile.trim() + '%' } });
        }

        filter['and'].push(or);
        if ((name !== '' && name !== null && name.length > 6) || (mobile !== '' && mobile !== null && mobile.length >= 10)) {
            dispatch({
                type: globalAddressActions.ADDRESS_DETAILS_START,
                url: 'addressBook',
                filter: {
                    where: filter,
                    order: sortBy + ' ' + sortOrder
                }
            });
            handleOpen();
        }
    }

    const factBox = [];
    const menus = [
        {
            "name": "Payment Details",
            "link": "/purchase/purchase-management/all-suppliers/paymentDetailsView",
            'disabled': true
        },
        {
            "name": "Create Order",
            "link": "",
            'disabled': true
        },
        {
            "name": "Create Self Bill",
            "link": `/purchase/purchase-management/self-bill/create`,
            'disabled': true
        },
        {
            "name": "Make Payment",
            "link": "",
            'disabled': true
        },
        {
            "name": "Invoice History",
            "link": "",
            'disabled': true
        },
        {
            "name": "Order History",
            "link": "",
            'disabled': true
        },
        {
            "name": "Planned Orders",
            "link": "",
            'disabled': true
        },
        {
            "name": "Settlement",
            "link": "",
            'disabled': true
        },
        {
            "name": "Transaction History",
            "link": "/purchase/purchase-transactions/supplier-transactions",
            'disabled': true
        }
    ];

    useEffect(() => {
        if (businessDetails && businessDetails !== '' && stateDetails && stateDetails?.length > 0) {
            if (businessDetails?.stateId) {
                changeState(businessDetails?.stateId);
                setPriceIncludesTax(businessDetails?.priceIncludesTax || false);
            }
        }
    }, [businessDetails, stateDetails]);

    useEffect(() => {
        if (countryId !== '') {
            setGstTypeList(taxType);
            if (taxTypeId === '' && taxType && taxType?.length > 0) {
                let a = taxType && taxType?.filter((el) => el.isDefault);
                if (a && a.length > 0) {
                    setTaxTypeId(a[0]?.id);
                    setGstCodeId(a[0]?.partyGstId || '');
                }
            }
        }
    }, [countryId, taxType]);

    useEffect(() => {
        if (roleManagement !== '' && checkCRUDViewPermission('All Suppliers', 'create', history, 'Purchase')) {
            setTimeout(function () {
                dispatch({ type: qucikLinksActions.QUICKLINKS_START, menus: menus, toggle: true, factBox: factBox, component: "All Suppliers" });
                childRef?.current?.handleAdjustHeight();
            }, 200);
            dispatch({
                type: addressActions.STATE_DETAILS_START, url: 'state', filter: {
                    order: 'id  desc'
                }
            });
            dispatch({
                type: gstActions.TAXCODE_DETAILS_START, url: 'taxcode', filter: {
                    order: 'id desc'
                }
            });
            dispatch({
                type: gstActions.CASHDISCOUNT_DETAILS_START, url: 'cashdiscount', filter: {
                    order: 'id desc'
                }
            });
            dispatch({
                type: gstActions.OTHERTAXES_DETAILS_START, url: 'othertaxes', filter: {
                    order: 'id desc'
                }
            });
            dispatch({
                type: addressActions.COUNTRY_DETAILS_START, url: 'country', filter: {
                    order: 'id  desc'
                }
            });
            dispatch({
                type: groupActions.SUPPLIERGROUP_DETAILS_START, url: 'supplier-group', filter: {
                    order: 'id  desc'
                }
            });
            dispatch({
                type: gstActions.PARTYGST_DETAILS_START, url: 'partygst', filter: {
                    order: 'id  desc'
                }
            });
            dispatch({
                type: addressActions.LANGUAGE_DETAILS_START, filter: {
                    order: 'id  desc'
                }
            });
            dispatch({
                type: gstActions.CURRENCY_DETAILS_START, url: 'currency', filter: {
                    order: 'id  desc'
                }
            });
            dispatch({
                type: gstActions.MOP_DETAILS_START, url: 'mop', filter: {
                    order: 'id  desc'
                }
            });
        }
        // return () => {
        //     dispatch({ type: businessActions.CLEAR_HOME_DETAILS_START });
        // }
        return () => {
            dispatch({ type: addressActions.CLEAR_ADDRESS_DETAILS_START });
            dispatch({ type: younoteAdminSetupActions.CLEAR_SETUP_START });
            dispatch({ type: actions.CLEAR_PURCHASE_MANAGEMENT_DETAILS_START });
        }
    }, [roleManagement]);



    const handleSubmit = (e) => {
        e.preventDefault();
        childRef?.current?.handleAdjustHeight();
        let emptyGstIn = {};
        let emailCheck = true;
        let emptyBusinessType = emptyValidation('Business Type', businessType, 'dropDown');
        let emptyName = emptyValidation('Name', name);
        let emptyMobile = emptyValidation('Mobile Number', mobile);
        let emptyEmail = customEmailValidation('Email', email);
        if (email !== '' && !emptyEmail.isValid) {
            emailCheck = false;
        }
        let emptyTaxTypeId = emptyValidation('Gst Type', taxTypeId, 'dropDown');
        let emptyLanguage = emptyValidation('Language', languageId, 'dropDown');
        let emptyCurrency = emptyValidation('Currency', currencyId, 'dropDown');
        // let emptyClassification = emptyValidation('Classification', classification);
        //let emptyalternateMobile = customPhoneValidationOptional('Alternate Phone', alternateMobile);
        // let emptyContactName = customAlaphabetValidationOptional('Contact Name', contactName);
        // let emptyAlternateName = customAlaphabetValidationOptional('Alternate Name', tradingName);
        let emptyPincode = emptyValidation('Pincode', pincodeId, 'dropDown');
        let emptyStateVal = emptyValidation('State', stateId, 'dropDown');

        let emptyGstCode = { isValid: true };
        if (taxTypeId !== '') {
            let a = taxType && taxType?.filter((el) => el.id === taxTypeId);
            if (a && a.length > 0 && (a[0].taxCode === 'UNRB' || a[0].taxCode === 'COMP' || a[0].taxCode === 'CONS')) {
                emptyGstIn = customAlaphaNumericValidationOptional('GST IN', gstin, 15);
            } else {
                emptyGstIn = customAlaphaNumericValidation('GST IN', gstin, 15);
            }

            if (a && a.length > 0) {
                if (a[0].taxCode === 'UNRB' || a[0].taxCode === 'COMP' || a[0].taxCode === 'CONS') {
                    emptyGstCode = { isValid: true }
                } else {
                    emptyGstCode = emptyValidation('Gst Code', gstCodeId, 'dropDown');
                }
            }
        }


        let emptyTcs = { isValid: true };
        if (tcs) {
            emptyTcs = emptyValidation('TCS', tcsId, 'dropDown');
        }

        emptyState();
        if (emptyBusinessType.isValid && emptyName.isValid && emailCheck && emptyMobile.isValid && emptyTaxTypeId.isValid
            && emptyLanguage.isValid && emptyCurrency.isValid && emptyGstCode.isValid
            && emptyGstIn.isValid && emptyPincode.isValid && emptyStateVal.isValid && emptyTcs.isValid) {
            let details = {
                type: businessType,
                name: name,
                email: email,
                mobile: mobile,
                isHold: isHold,
                // classification: classification,
                languageId: languageId,
                taxTypeId: taxTypeId,
                gstin: gstin,
                address1: address1 ? address1 : '',
                tradingName: tradingName,
                alternateMobile: alternateMobile,
                currencyId: currencyId,
                countryId: countryId,
                businessId: getBusinessId(),
                priceIncludesTax: priceIncludesTax || false,
                taxCodeId: taxCodeId || 0,
                tcsId: tcsId || 0,
                tdsId: tdsId || 0,
                tcsBoolean: tcs || false,
                tdsBoolean: tds || false,
                cashDiscountId: cashDiscountId || 0
            };

            if (pan) {
                let ideType = identityType || 'PAN';
                details["pan"] = ideType + '-' + pan;
            } else {
                details["pan"] = '';
            }

            if (contactName) {
                details["contactName"] = contactName;
            }

            if (gabId) {
                details["gabId"] = gabId;
            }

            if (groupId) {
                details["groupId"] = groupId;
            }

            if (gstCodeId) {
                details["partyGstId"] = gstCodeId;
            }

            if (mopId) {
                details["mopId"] = mopId;
            }

            if (areaId) {
                details["areaId"] = areaId;
            }

            if (pincodeId) {
                details["pincodeId"] = pincodeId;
            }

            if (stateId) {
                details["stateId"] = stateId;
            }

            if (cityId) {
                details["cityId"] = cityId;
            }

            if (classification) {
                details["classification"] = classification;
            }

            if (younoteID) {
                details["inAppStatus"] = 'REQUEST SENT';
                details["inAppTransition"] = true;
                details["supplierBusinessId"] = younoteID;
            } else {
                details["inAppStatus"] = 'NO';
                details["inAppTransition"] = false;
            }

            dispatch({
                type: crudActions.CREATE_DETAILS_START,
                url: "supplierProfile",
                title: "Supplier Profile",
                details: details
            });

        } else {
            if (emptyBusinessType.errors) {
                setErroBusinessType(emptyBusinessType.errors);
            }
            if (emptyName.errors) {
                setErrorName(emptyName.errors);
            }
            if (emptyMobile.errors) {
                setErrorMobile(emptyMobile.errors);
            }
            if (email !== '' && emptyEmail.errors) {
                setErrorEmail(emptyEmail.errors);
            }
            if (emptyTcs.errors) {
                setErrorTcs(emptyTcs.errors);
            }
            if (emptyLanguage.errors) {
                setErrorLanguage(emptyLanguage.errors);
            }
            if (emptyCurrency.errors) {
                setErrorCurrency(emptyCurrency.errors);
            }
            if (emptyPincode.errors) {
                setErrorPincode(emptyPincode.errors);
            }

            if (emptyStateVal.errors) {
                setErrorState(emptyStateVal.errors);
            }

            if (emptyTaxTypeId.errors) {
                setErrorGstType(emptyTaxTypeId.errors);
            }

            if (emptyGstCode.errors) {
                setErrorGstCode(emptyGstCode.errors);
            }

            // if (emptyClassification.errors) {
            //     setErrorClassification(emptyClassification.errors);
            // }
            // if (emptyContactName.errors) {
            //     setErrorContactForm(emptyContactName.errors);
            // }
            // if (emptyAlternateName.errors) {
            //     setErroremptyAlternateName(emptyAlternateName.errors);
            // }
            // if (emptyalternateMobile.errors) {
            //     setErroremptyAlternateNumber(emptyalternateMobile.errors);
            // }
            if (emptyGstIn.errors) {
                setErrorGstIn(emptyGstIn.errors);
            }
            scrollToError();
        }
    }

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            toast.dismiss();
            // toast(createDetails);
            if (roleManagement !== '' && checkCRUDPermission('All Suppliers', 'view', 'Purchase')) {
                history.push(`/purchase/purchase-management/all-suppliers/${AESEncrypt(createData.id)}/view`, 'create');
            } else {
                history.push(`/purchase/purchase-management/all-suppliers`);
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let message = createError.error.message;
            toast.dismiss();
            toast.error(message);
        }
    }, [createDetails, createError]);

    const handleClose = () => {
        setVisible(false);
    };

    const handleOpen = () => {
        setVisible(true);
    };

    const changeArea = (value) => {
        setAreaId(value);
    }


    const handleChangeCountry = (value) => {
        setCountryId(value);
        setStateId('');
        setCityId('');
        setPincodeId('');
        setAreaId('');
        let a = countryDetails && countryDetails.filter(function (el) { return el.id === value });
        if (a && a?.length !== 0) {
            setCurrencyId(a[0].currencyId);
        }
        dispatch({
            type: younoteAdminSetupActions.TAX_TYPE_START,
            url: `/tax-types/byCountry/${value}`,
            // filter: {
            //     where: { countryTaxId: 1 }
            // }
        });
    }

    useEffect(() => {
        if ((prevAddressSearchAll !== undefined && addressSearchAll && addressSearchAll.length > 4 && prevAddressSearchAll !== addressSearchAll)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            timeoutRef.current = setTimeout(() => {
                timeoutRef.current = null;
                let filter = { "or": [] };
                filter['or'].push({ businessName: { like: addressSearchAll.trim() + '%' } });
                filter['or'].push({ mobile: { like: addressSearchAll.trim() + '%' } });
                filter['or'].push({ email: { like: addressSearchAll.trim() + '%' } });
                dispatch({
                    type: globalAddressActions.ADDRESS_DETAILS_START,
                    url: 'addressBook',
                    filter: {
                        where: filter,
                        order: sortBy + ' ' + sortOrder
                    }
                });
            }, 500);
        }
    }, [addressSearchAll]);

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const changePincode = (value) => {
        setPincodeId(value);
        setAreaId('');
        let a = pincodeDetails && pincodeDetails.filter(function (el) { return el.id === value });
        if (a && a?.length !== 0) {
            setCityId(a[0].cityId);
            dispatch({
                type: addressActions.AREA_DETAILS_START, url: 'areas', filter: {
                    where: { "and": [{ pincodeId: value }] }
                }
            });
        }
        return [];
    }

    const changeCity = (value) => {
        setCityId(value);
        setAreaId('');
        setPincodeId('');
    }

    const changeState = (value) => {
        setStateId(value);
        setCityId('');
        setPincodeId('');
        setAreaId('');
        let a = stateDetails && stateDetails.filter(function (el) { return el.id === value });
        if (a && a?.length !== 0) {
            setCountryId(a[0].countryId);
            setCurrencyId(a[0].country && a[0].country.currencyId);
            dispatch({
                type: younoteAdminSetupActions.TAX_TYPE_START,
                url: `/tax-types/byCountry/${a[0].countryId}`
            });
        }
        changeStateApi(value);
    }

    const changeStateApi = (value) => {
        dispatch({
            type: addressActions.PINCODE_DETAILS_START, url: 'pincode', filter: {
                where: { "and": [{ stateId: value }] }
            }
        });
        dispatch({
            type: addressActions.CITY_DETAILS_START, url: 'city', filter: {
                where: { "and": [{ stateId: value }] }
            }
        });
    }

    const handleBusinessType = (value) => {
        setBusinessType(value);
        if (value === 'INDIVIDUAL') {
            setClassification("OTHER");
        } else {
            setClassification('');
        }
    }

    const handlePartyGstDetails = () => {
        let result = partyGstdetails;
        if (taxTypeId !== '' && taxType && taxType.length > 0) {
            let a = taxType && taxType?.filter((el) => el.id === taxTypeId);
            if (a && a.length > 0 && a[0]?.taxCode === 'SPEZ') {
                result = partyGstdetails.filter((el) => { return el.isSEZ })
            }
        }
        return result;
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props}
                img={PurchaseIcon}
                title={'Purchase'}
                links={[{ 'label': 'Purchase', 'link': '/purchase' }, { 'label': 'All Suppliers', 'link': '/purchase/purchase-management/all-suppliers' }, { 'label': 'Supplier Details', 'link': '' }]}
            />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.listTableSticky, classes.scrollBorder)}>
                <div id="containerDiv" className={clsx(classes.stickyContainer)}>
                    <CustomAccordion
                        title={'Add Supplier'}
                        top={"0"}
                        topVisible={"50px"}
                        zIndex={9}
                        ref={childRef}
                        showDetails={false}
                        index={0}
                        component={
                            <>
                                <Box
                                    className={clsx(classes.removeUnderline)}
                                    component="form"
                                    autoComplete="off"

                                    onSubmit={(e) => handleSubmit(e)}>
                                    <Row>
                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={classes.textAlignCenter}>
                                            {
                                                commonError && <CustomAlert error={commonError} customClass={clsx(classes.uploadError)} />
                                            }
                                        </Col>
                                        <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
                                            <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold)}>General</Typography>
                                        </Col>

                                        <Col xxl={20} xl={20} lg={20} md={20} sm={20} xs={20} className={classes.textAlignRight}>
                                            <Button
                                                type='submit'
                                                color='primary'
                                                variant="contained"
                                                tabIndex={-1}
                                                id={idNamingConversion('Submit', 'supplierProfile', 'Button')}
                                                className={clsx(classes.modalBtn, { [classes.loading]: createLoader })}>
                                                Save
                                            </Button>
                                        </Col>
                                    </Row>
                                    <Row gutter={50}>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <AutoCompleteComponent
                                                name={["Business Type ", <span key={"Business Type"} className={classes.colorRedRequired}> *</span>]}
                                                heads={[{ 'key': 'label', 'name': 'Name' }]}
                                                details={customerTypeList}
                                                id={idNamingConversion('Business Type', 'supplierProfile', 'DropDown')}
                                                parentValue={customObject(customerTypeList, businessType)}
                                                onChange={(data) => handleBusinessType(data.id)}
                                                position={"bottom"}
                                                customClasses={classes.margin20t}
                                                parentError={errorBusinessType}
                                            />
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <TextField autoComplete='one-time-code'
                                                label={["Supplier Name ", <span key={"Supplier Name"} className={classes.colorRedRequired}> *</span>]}
                                                fullWidth
                                                error={errorName && true}
                                                helperText={errorName}
                                                value={name}
                                                variant={'standard'}
                                                id={idNamingConversion('Supplier Name', 'supplierProfile', 'TextField')}
                                                className={classes.margin20t}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                        inputMode: 'numeric', pattern: '[0-9]*'
                                                    },
                                                    endAdornment: (
                                                        <InputAdornment position="end" onClick={(e) => addressSearch(e)} >
                                                            <IconButton tabIndex={-1}>
                                                                <Search />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    )
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom
                                                }}
                                                onChange={(e) => setName(e.target.value)}
                                            />
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <FormControlLabel
                                                classes={{
                                                    label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink')  // Pass your override css here
                                                }}
                                                id={idNamingConversion('Hold', 'supplierProfile', 'Radio')}
                                                control={<Switch size='small'
                                                    className={clsx(classes.customSwitch)}
                                                    onChange={(e) => setIsHold(!isHold)}
                                                    checked={isHold}
                                                />}
                                                label="Hold"
                                                labelPlacement="top"
                                                className={clsx(classes.marginLeft0, classes.flexStart, classes.margin20t)}
                                            />
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <FormControlLabel
                                                classes={{
                                                    label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink') // Pass your override css here
                                                }}
                                                id={idNamingConversion('Price Include Tax', 'supplierProfile', 'Radio')}
                                                control={<Switch size='small'
                                                    className={clsx(classes.customSwitch)}
                                                    onChange={(e) => setPriceIncludesTax(!priceIncludesTax)}
                                                    checked={priceIncludesTax}
                                                />}
                                                label="Price Includes Tax"
                                                labelPlacement="top"
                                                className={clsx(classes.marginLeft0, classes.flexStart, classes.margin20t)}
                                            />
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <TextField autoComplete='one-time-code'
                                                label={["Mobile Number ", <span key={"Mobile Number"} className={classes.colorRedRequired}> *</span>]}
                                                fullWidth
                                                //  type='number'
                                                id={idNamingConversion('Mobile Number', 'supplierProfile', 'TextField')}
                                                error={errorMobile && true}
                                                helperText={errorMobile}
                                                value={mobile}
                                                variant={'standard'}
                                                className={clsx(classes.margin20t)}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    },
                                                    endAdornment: (
                                                        <InputAdornment position="end" onClick={(e) => addressSearch(e)} >
                                                            <IconButton tabIndex={-1}>
                                                                <Search />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    )
                                                }}
                                                onWheel={(e) => e.target.blur()}
                                                // onKeyDown={(e) => handleKeyDown(e)}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => setMobile(e.target.value)}
                                            />
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <TextField autoComplete='one-time-code'
                                                label='Email'
                                                fullWidth
                                                value={email}
                                                id={idNamingConversion('Email', 'supplierProfile', 'TextField')}
                                                error={errorEmail && true}
                                                helperText={errorEmail}
                                                variant={'standard'}
                                                className={clsx(classes.margin20t)}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => setEmail(e.target.value)}
                                            />
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <AutoCompleteComponent
                                                name={["Classification"]}
                                                heads={[{ 'key': 'label', 'name': 'Name' }]}
                                                details={classificationList}
                                                parentValue={customObject(classificationList, classification)}
                                                onChange={(data) => setClassification(data.id)}
                                                position={"bottom"}
                                                id={idNamingConversion('Classification', 'supplierProfile', 'DropDown')}
                                                parentError={errorClassification}
                                                customClasses={classes.margin20t}
                                                onChangeText={(value) => {
                                                    if (value === '') {
                                                        setClassification('')
                                                    }
                                                }}
                                            />
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <AutoCompleteComponent
                                                name={["Preferred Language ", <span key={"Preferred Language"} className={classes.colorRedRequired}> *</span>]}
                                                heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                details={languageDetails}
                                                id={idNamingConversion('Preferred Language', 'supplierProfile', 'DropDown')}
                                                parentValue={customObject(languageDetails, languageId)}
                                                onChange={(data) => setLanguageId(data.id)}
                                                position={"bottom"}
                                                parentError={errorLanguage}
                                                customClasses={classes.margin20t}
                                            />
                                        </Col>
                                        <Col xxl={4} xl={4} lg={6} md={8} sm={12} xs={24}>
                                            <AutoCompleteComponent
                                                name={["Group "]}
                                                heads={[{ 'key': 'name', 'name': 'Name' },
                                                { 'key': 'description', 'name': 'Description' }]}
                                                details={supplierGroupDetails}
                                                id={idNamingConversion('Group', 'supplierProfile', 'DropDown')}
                                                parentValue={customObject(supplierGroupDetails, groupId)}
                                                onChange={(data) => setGroupId(data.id)}
                                                onChangeText={(value) => {
                                                    if (value === '') {
                                                        setGroupId('')
                                                    }
                                                }}
                                                position={"bottom"}
                                                customClasses={classes.margin20t}
                                            />
                                        </Col>
                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                            <Typography variant={'h6'} className={clsx(classes.customLink, classes.margin35t, classes.typographyHeader, classes.bold)}>GST Details</Typography>
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <AutoCompleteComponent
                                                name={["GST Type ", <span key={"GST Type"} className={classes.colorRedRequired}> *</span>]}
                                                heads={[{ 'key': 'name', 'name': 'Name' },
                                                { 'key': 'taxCode', 'name': 'Code' }]}
                                                details={gstTypeList}
                                                id={idNamingConversion('GST Type', 'supplierProfile', 'DropDown')}
                                                parentValue={customObject(gstTypeList, taxTypeId)}
                                                onChange={(data) => {
                                                    setTaxTypeId(data.id);
                                                    setGstCodeId(data?.partyGstId || '');
                                                }}
                                                parentError={errorGstType}
                                                position={"bottom"}
                                                customClasses={clsx(classes.margin20t, classes.dropDownPointer)}
                                            />
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <AutoCompleteComponent
                                                name={["Party GST Code "]}
                                                heads={[{ 'key': 'code', 'name': 'Party GST Code' },
                                                { 'key': 'description', 'name': 'Description' }]}
                                                id={idNamingConversion('Party GST Code', 'supplierProfile', 'DropDown')}
                                                details={handlePartyGstDetails()}
                                                parentValue={customObject(handlePartyGstDetails(), gstCodeId)}
                                                onChange={(data) => setGstCodeId(data.id)}
                                                parentError={errorGstCode}
                                                position={"bottom"}
                                                customClasses={classes.margin20t}
                                            />
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <TextField autoComplete='one-time-code'
                                                label='GST Number (GSTIN)'
                                                fullWidth
                                                error={errorGstIn && true}
                                                helperText={errorGstIn}
                                                value={gstin}
                                                variant={'standard'}
                                                id={idNamingConversion('GST Number', 'supplierProfile', 'TextField')}
                                                className={clsx(classes.margin20t)}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => setGstin(e.target.value)}
                                            />
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <FormControl
                                                tabIndex={-1}
                                                className={clsx(classes.margin20t, classes.dropDownPointer, classes.customRadioButton, classes.customIdentityRadioButton)}
                                                variant={'standard'}
                                                fullWidth>
                                                <FormLabel className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Identity Type</FormLabel>
                                                <RadioGroup row
                                                    defaultValue={"PAN"}
                                                    aria-labelledby="demo-customized-radios"
                                                    name="identityType"
                                                    value={identityType || "PAN"}
                                                    onChange={(e) => setIdentityType(e.target.value)}>
                                                    <FormControlLabel value={"PAN"} control={<Radio
                                                        checkedIcon={<UnSelectedIcon />}
                                                        icon={<SelectedIcon />}
                                                    />} label="PAN" />
                                                    <FormControlLabel value={"TAN"} control={<Radio
                                                        checkedIcon={<UnSelectedIcon />}
                                                        icon={<SelectedIcon />}
                                                    />} label="TAN" />
                                                    <FormControlLabel value={"CIN"} control={<Radio
                                                        checkedIcon={<UnSelectedIcon />}
                                                        icon={<SelectedIcon />}
                                                    />} label="CIN" />
                                                    <FormControlLabel value={'LIC'} control={<Radio
                                                        checkedIcon={<UnSelectedIcon />}
                                                        icon={<SelectedIcon />}
                                                    />} label="License Number" />
                                                </RadioGroup>
                                            </FormControl>
                                        </Col>
                                        <Col xxl={4} xl={4} lg={6} md={8} sm={12} xs={24}>
                                            <TextField autoComplete='one-time-code'
                                                label={`${identityType || "PAN"} Number`}
                                                fullWidth
                                                id={idNamingConversion("PAN Number", 'customerProfile', 'TextField')}
                                                value={pan}
                                                variant={'standard'}
                                                className={clsx(classes.margin20t)}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => setPan(e.target.value)}
                                            />
                                        </Col>
                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                            <Typography variant={'h6'} className={clsx(classes.customLink, classes.margin35t, classes.typographyHeaderToolTip, classes.typographyHeader, classes.bold)}>
                                                <span>Address</span>
                                                <Tooltip
                                                    classes={{ popper: clsx(classes.customToolTip, classes.customToolTipWidth) }}
                                                    title={'Billing Address'} arrow placement="top" className={classes.tooltip}>
                                                    <IconButton>
                                                        <Image src={infoMarkIcon} preview={false} />
                                                    </IconButton>
                                                </Tooltip>

                                            </Typography>
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <AutoCompleteComponent
                                                name={["State/Province ", <span key={"State/Province"} className={classes.colorRedRequired}> *</span>]}
                                                heads={[{ 'key': 'name', 'name': 'State Name' },
                                                { 'key': 'country', 'name': 'Country Name', 'relation': 'name' }]}
                                                details={stateDetails}
                                                id={idNamingConversion('State', 'supplierProfile', 'DropDown')}
                                                parentValue={customObject(stateDetails, stateId)}
                                                onChange={(data) => changeState(data.id)}
                                                position={"top"}
                                                customClasses={classes.margin20t}
                                                parentError={errorState}
                                                infoMark={'The value selected in this field defaults from your Business address. Please select the correct State address for the Party record.'}
                                            />
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <AutoCompleteComponent
                                                name={["Pincode ", <span key={"Pincode"} className={classes.colorRedRequired}> *</span>]}
                                                heads={[{ 'key': 'code', 'name': 'Pincode' },
                                                { 'key': 'city', 'name': 'City', 'relation': 'name' }]}
                                                details={pincodeDetails}
                                                id={idNamingConversion('Pincode', 'supplierProfile', 'DropDown')}
                                                parentValue={customObject(pincodeDetails, pincodeId)}
                                                onChange={(data) => changePincode(data.id)}
                                                position={"top"}
                                                customClasses={classes.margin20t}
                                                parentError={errorPincode}
                                            />
                                        </Col>
                                        <Col xxl={14} xl={14} lg={14} md={14} sm={14} xs={14}></Col>
                                        <Col xxl={10} xl={10} lg={24} md={24} sm={24} xs={24}>
                                            <Row gutter={50}>
                                                <Col xxl={12} xl={12} lg={6} md={8} sm={12} xs={24}>
                                                    <TextField autoComplete='one-time-code'
                                                        label=''
                                                        value={address1}
                                                        id={idNamingConversion('Address', 'supplierProfile', 'TextField')}
                                                        placeholder='Door/Building Number,&#10;Building Name&#10;Street Address&#10;Locality'
                                                        variant={'outlined'}
                                                        className={clsx(classes.margin20t, classes.customDescription)}
                                                        fullWidth
                                                        multiline
                                                        name={"address"}
                                                        rows={6}
                                                        InputProps={{
                                                            classes: {
                                                                input: classes.textFieldColor,
                                                            },
                                                            style: { height: 170 },
                                                        }}
                                                        InputLabelProps={{
                                                            className: classes.textFieldLableColor,
                                                        }}
                                                        onChange={(e) => setAddress1(e.target.value)}
                                                    />
                                                </Col>
                                                <Col xxl={12} xl={12} lg={6} md={8} sm={12} xs={24}>
                                                    <AutoCompleteComponent
                                                        name={["Area"]}
                                                        heads={[{ 'key': 'name', 'name': 'Area Name' },
                                                        { 'key': 'pincode', 'name': 'Pincode', 'relation': 'code' },
                                                        { 'key': 'city', 'name': 'City', 'relation': 'name' },
                                                        { 'key': 'state', 'name': 'State', 'relation': 'shortName' }]}
                                                        details={areaDetails}
                                                        id={idNamingConversion('Area', 'supplierProfile', 'DropDown')}
                                                        parentValue={customObject(areaDetails, areaId)}
                                                        onChange={(data) => { changeArea(data.id) }}
                                                        position={"top"}
                                                        customClasses={classes.margin20t}
                                                        customLink={'/admin/address/area'}
                                                        linkText={'Go to Area'}
                                                        infoMark={'Select the local postal area from the list or Goto Area master to create a new record for the missing area info. The field is optional and will take blank values.'}
                                                    />
                                                    <AutoCompleteComponent
                                                        name={["Dist/City/Town"]}
                                                        heads={[{ 'key': 'name', 'name': 'Name' },
                                                        { 'key': 'state', 'name': 'State Name', 'relation': 'shortName' }]}
                                                        details={cityDetails}
                                                        id={idNamingConversion('City', 'supplierProfile', 'DropDown')}
                                                        parentValue={customObject(cityDetails, cityId)}
                                                        onChange={(data) => changeCity(data.id)}
                                                        position={"top"}
                                                        customClasses={classes.margin20t}
                                                    />
                                                    <AutoCompleteComponent
                                                        name={["Country"]}
                                                        heads={[{ 'key': 'name', 'name': 'Country Name' }]}
                                                        details={countryDetails}
                                                        id={idNamingConversion('Country', 'supplierProfile', 'DropDown')}
                                                        parentValue={customObject(countryDetails, countryId)}
                                                        onChange={(data) => handleChangeCountry(data.id)}
                                                        position={"top"}
                                                        customClasses={classes.margin20t}
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col xxl={14} xl={14} lg={14} md={14} sm={14} xs={14}></Col>
                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                            <Typography variant={'h6'} className={clsx(classes.customLink, classes.margin35t, classes.typographyHeader, classes.bold)}>Other Contact Details</Typography>
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <TextField autoComplete='one-time-code'
                                                fullWidth
                                                error={errorContactForm && true}
                                                helperText={errorContactForm}
                                                label='Contact Name'
                                                value={contactName}
                                                variant={'standard'}
                                                id={idNamingConversion('Contact Name', 'supplierProfile', 'TextField')}
                                                className={clsx(classes.margin20t)}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => setContactName(e.target.value)}
                                            />
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <TextField autoComplete='one-time-code'
                                                label='Alternate Name (Optional)'
                                                fullWidth
                                                error={erroremptyAlternateName && true}
                                                helperText={erroremptyAlternateName}
                                                value={tradingName}
                                                variant={'standard'}
                                                id={idNamingConversion('Alternate Name', 'supplierProfile', 'TextField')}
                                                className={clsx(classes.margin20t)}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => setTradingName(e.target.value)}
                                            />
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <TextField autoComplete='one-time-code'
                                                label='Alternate Phone'
                                                value={alternateMobile}
                                                type='number'
                                                // error={erroremptyAlternateNumber && true}
                                                // helperText={erroremptyAlternateNumber}
                                                fullWidth
                                                id={idNamingConversion('Alternate Phone', 'supplierProfile', 'TextField')}
                                                variant={'standard'}
                                                className={clsx(classes.margin20t)}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                onWheel={(e) => e.target.blur()}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => setAlternateMobile(e.target.value)}
                                            />
                                        </Col>
                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                            <Typography variant={'h6'} className={clsx(classes.customLink, classes.margin35t, classes.typographyHeader, classes.bold)}>Payment Info</Typography>
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <AutoCompleteComponent
                                                name={["Method of payment (MOP)"]}
                                                heads={[{ 'key': 'method', 'name': 'Method' },
                                                { 'key': 'description', 'name': 'Description' }]}
                                                details={mopDetails}
                                                parentValue={customObject(mopDetails, mopId)}
                                                onChange={(data) => setMopId(data.id)}
                                                id={idNamingConversion('Method of payment', 'supplierProfile', 'DropDown')}
                                                onChangeText={(value) => {
                                                    if (value === '') {
                                                        setMopId('')
                                                    }
                                                }}
                                                position={"top"}
                                                customClasses={classes.margin20t}
                                            />
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <AutoCompleteComponent
                                                name={["Currency ", <span key={"Currency"} className={classes.colorRedRequired}> *</span>]}
                                                heads={[{ 'key': 'name', 'name': 'Currency Name' },
                                                { 'key': 'shortName', 'name': 'Currency Short Form' }]}
                                                details={currencyDetails}
                                                parentValue={customObject(currencyDetails, currencyId)}
                                                onChange={(data) => setCurrencyId(data.id)}
                                                parentError={errorCurrency}
                                                position={"top"}
                                                id={idNamingConversion('Currency', 'supplierProfile', 'DropDown')}
                                                customClasses={classes.margin20t}
                                            />
                                        </Col>
                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                            <Typography variant={'h6'} className={clsx(classes.customLink, classes.margin35t, classes.typographyHeader, classes.bold)}>Younote Info</Typography>
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={8} xs={24} className={classes.margin20t}>
                                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Younote ID</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{younoteID ? younoteSerial : '---'}</Typography>
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={8} xs={24} className={classes.margin20t}>
                                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>In-App Status</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{inAppStatus ? capitalizeFirstLetter(inAppStatus) : 'No'}</Typography>
                                        </Col>
                                        <Col xxl={14} xl={14} lg={6} md={8} sm={8} xs={24} className={classes.margin20t}>
                                            <FormControlLabel
                                                classes={{
                                                    label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink')  // Pass your override css here
                                                }}
                                                control={<Switch size='small' className={clsx(classes.customSwitch)} />
                                                }
                                                id={idNamingConversion('In-AppTransactions', 'supplierProfile', 'Radio')}
                                                label="In-AppTransactions"
                                                checked={false}
                                                labelPlacement="top"
                                                disabled={false}
                                                className={clsx(classes.marginLeft0, classes.flexStart)}
                                            />
                                        </Col>
                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                            <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>
                                                Other Taxes</Typography>
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <AutoCompleteComponent
                                                name={["Cash Discount"]}
                                                heads={[{ 'key': 'code', 'name': 'Code' }]}
                                                details={cashDiscountDetails || []}
                                                id={idNamingConversion('Cash Discount', 'supplierProfile', 'DropDown')}
                                                parentValue={customObject(cashDiscountDetails || [], cashDiscountId)}
                                                onChange={(data) => setCashDiscountId(data.id)}
                                                position={"top"}
                                                customClasses={classes.margin20t}
                                            />
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <AutoCompleteComponent
                                                name={["Tax Code "]}
                                                heads={[{ 'key': 'code', 'name': 'Code' }]}
                                                details={taxCodedetails}
                                                id={idNamingConversion('Tax Code', 'supplierProfile', 'DropDown')}
                                                parentValue={customObject(taxCodedetails, taxCodeId)}
                                                onChange={(data) => setTaxCodeId(data.id)}
                                                position={"top"}
                                                customClasses={classes.margin20t}
                                            />
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={8} xs={24}>
                                            <FormControlLabel
                                                classes={{
                                                    label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink') // Pass your override css here
                                                }}
                                                id={idNamingConversion('TCS', 'supplierProfile', 'Radio')}
                                                control={<Switch size='small'
                                                    className={clsx(classes.customSwitch)}
                                                    onChange={(e) => setTcs(!tcs)}
                                                    checked={tcs}
                                                />}
                                                label="TCS"
                                                labelPlacement="top"
                                                className={clsx(classes.marginLeft0, classes.flexStart, classes.margin20t)}
                                            />
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={8} xs={24}>
                                            <FormControlLabel
                                                classes={{
                                                    label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink') // Pass your override css here
                                                }}
                                                id={idNamingConversion('TDS', 'supplierProfile', 'Radio')}
                                                control={<Switch size='small'
                                                    className={clsx(classes.customSwitch)}
                                                    onChange={(e) => setTds(!tds)}
                                                    checked={tds}
                                                />}
                                                label="TDS"
                                                labelPlacement="top"
                                                className={clsx(classes.marginLeft0, classes.flexStart, classes.margin20t)}
                                            />
                                        </Col>
                                        {
                                            tcs && <Col xxl={4} xl={4} lg={6} md={8} sm={12} xs={24}>
                                                <AutoCompleteComponent
                                                    name={["TCS "]}
                                                    heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                    details={(otherTaxesdetails || []).filter(el => el.taxType === 'TCS')}
                                                    id={idNamingConversion('TCS', 'supplierProfile', 'DropDown')}
                                                    parentValue={customObject((otherTaxesdetails || []).filter(el => el.taxType === 'TCS'), tcsId)}
                                                    onChange={(data) => setTcsId(data.id)}
                                                    position={"top"}
                                                    customClasses={classes.margin20t}
                                                    parentError={errorTcs}
                                                />
                                            </Col>
                                        }
                                    </Row>
                                </Box>
                            </>
                        }
                    />
                    {/* <CustomAccordion
                        title={'Purchase Price Details'}
                        top={"49"}
                        topVisible={"150px"}
                        zIndex={7}
                        showDetails={false}
                        index={1}
                        ref={childRef}
                        component={
                            <>
                            </>
                        }
                    /> */}
                    {/* <CustomAccordion
                        title={'Supplier Products'}
                        top={"113"}
                        topVisible={"250px"}
                        zIndex={5}
                        showDetails={false}
                        index={2}
                        ref={childRef}
                        component={
                            <>
                            </>
                        }
                    />
                    <CustomAccordion
                        title={'Minimum Stock Quantity'}
                        top={"178"}
                        topVisible={"350px"}
                        zIndex={3}
                        showDetails={false}
                        index={3}
                        ref={childRef}
                        component={
                            <>
                            </>
                        }
                        lastContent={true}
                    /> */}
                </div>
            </div>
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={'Global Address Book'}
                width={"690px"}
                className={clsx(classes.closeBackGround, classes.width100PCustomerandSales)}
                component={
                    <PrimaryCard
                        customClass={classes.addressTable}
                        component={
                            <>
                                <Row align="middle" className={classes.marginBottom20}>
                                    <Col xxl={8} xl={8} lg={12} md={12} sm={12} xs={24}>
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search'
                                                type='search'
                                                fullWidth
                                                onChange={(e) => setAddressSearchAll(e.target.value)}
                                                className={classes.comInput}
                                                variant={'standard'}
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                                id={idNamingConversion('Address Book Search', 'supplierProfile', 'TextField')}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <AddressTable selectAddress={(data) => selectAddress(data)} details={addressDetails} loader={addressLoader} sortOrder={sortOrder} sortBy={sortBy} />
                            </>
                        }
                    />
                }
            />
            <QuickLinks menus={menus} factBox={true} component={"All Suppliers"}></QuickLinks>
        </React.Fragment>
    )
}
export default SupplierCreate